(function () {
    if (window.tcGiftMessageScriptReady) return;
    window.tcGiftMessageScriptReady = true;

    function initGiftMessage(root) {
      if (!root || root.dataset.tcGiftMessageReady === 'true') return;
      root.dataset.tcGiftMessageReady = 'true';

      var toggle = root.querySelector('[data-tc-gift-message-toggle]');
      var hiddenInput = root.querySelector('[data-tc-gift-message-input]');
      var modal = root.querySelector('[data-tc-gift-message-modal]');
      var textarea = root.querySelector('[data-tc-gift-message-textarea]');
      var save = root.querySelector('[data-tc-gift-message-save]');
      var preview = root.querySelector('[data-tc-gift-message-preview]');
      var label = root.querySelector('[data-tc-gift-message-label]');
      var editButton = root.querySelector('[data-tc-gift-message-edit]');
      var closeButtons = root.querySelectorAll('[data-tc-gift-message-close]');
      var giftMessagePropertyName = root.dataset.tcGiftMessagePropertyName || 'Mesaj pe placuta din lemn';
      var productForm = null;
      var formPropertyInput = null;
      var componentInstanceId =
        root.id + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
      root.dataset.tcGiftMessageInstance = componentInstanceId;

      function isActiveGiftRoot() {
        return document.documentElement.contains(root);
      }

      function getProductForm() {
        if (!isActiveGiftRoot()) return null;
        if (productForm && document.documentElement.contains(productForm)) return productForm;

        var formComponent = root.closest('product-form-component');
        productForm = formComponent
          ? formComponent.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')
          : root.closest('form');

        if (productForm && !productForm.id) {
          productForm.id = 'tc-gift-message-form-' + root.id;
        }

        return productForm;
      }

      function removeFormPropertyInput() {
        if (formPropertyInput && formPropertyInput.parentNode) {
          formPropertyInput.parentNode.removeChild(formPropertyInput);
        }
        formPropertyInput = null;
      }

      function ensureFormPropertyInput(form, value) {
        if (!form) {
          removeFormPropertyInput();
          return;
        }

        if (!toggle.checked || !value) {
          removeFormPropertyInput();
          return;
        }

        if (!formPropertyInput || !form.contains(formPropertyInput)) {
          formPropertyInput = form.querySelector('[data-tc-gift-message-form-input]');
        }

        if (!formPropertyInput) {
          formPropertyInput = document.createElement('input');
          formPropertyInput.type = 'hidden';
          formPropertyInput.setAttribute('data-tc-gift-message-form-input', 'true');
          form.appendChild(formPropertyInput);
        }

        formPropertyInput.name = 'properties[' + giftMessagePropertyName + ']';
        formPropertyInput.value = value;
        formPropertyInput.disabled = false;
      }

      function syncHiddenInputWithForm() {
        var form = getProductForm();
        var value = hiddenInput.value.trim();

        hiddenInput.name = 'properties[' + giftMessagePropertyName + ']';
        hiddenInput.disabled = !toggle.checked || !value;

        if (form && form.id) {
          hiddenInput.setAttribute('form', form.id);
        }

        ensureFormPropertyInput(form, value);
      }

      function openModal() {
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }

        modal.hidden = false;
        document.documentElement.classList.add('tc-gift-message-open');
        document.documentElement.style.overflow = 'hidden';
        setTimeout(function () {
          textarea.focus();
        }, 30);
      }

      function closeModal() {
        modal.hidden = true;
        document.documentElement.classList.remove('tc-gift-message-open');
        document.documentElement.style.overflow = '';
        if (!hiddenInput.value.trim()) {
          toggle.checked = false;
        }
        syncHiddenInputWithForm();
        textarea.value = hiddenInput.value;
      }

      function saveMessage() {
        var value = textarea.value.trim();
        hiddenInput.value = value;
        toggle.checked = value !== '';
        syncHiddenInputWithForm();
        preview.textContent = value;
        label.textContent = value ? 'Mesaj personalizat salvat' : 'Adaugă mesaj gratuit pe plăcuța din lemn';
        closeModal();
      }

      function clearMessage() {
        textarea.value = '';
        hiddenInput.value = '';
        hiddenInput.disabled = true;
        hiddenInput.removeAttribute('form');
        removeFormPropertyInput();
        toggle.checked = false;
        preview.textContent = '';
        label.textContent = 'Adaugă mesaj gratuit pe plăcuța din lemn';
      }

      root.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      root.addEventListener('pointerdown', function (event) {
        event.stopPropagation();
      });

      ['mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(function (eventName) {
        root.addEventListener(eventName, function (event) {
          event.stopPropagation();
        });
      });

      modal.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      editButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggle.checked = true;
        textarea.value = hiddenInput.value;
        openModal();
      });

      toggle.addEventListener('change', function () {
        if (toggle.checked) {
          textarea.value = hiddenInput.value;
          openModal();
        } else {
          clearMessage();
        }
      });

      function bindProductFormSubmit() {
        var form = getProductForm();
        if (!form || form.dataset.tcGiftMessageSubmitReady === componentInstanceId) return;
        form.dataset.tcGiftMessageSubmitReady = componentInstanceId;

        form.addEventListener('submit', function () {
          if (!isActiveGiftRoot()) return;
          syncHiddenInputWithForm();
        }, true);
      }

      function syncBeforeProductFormAction(event) {
        if (!isActiveGiftRoot()) return;

        var form = getProductForm();
        var target = event && event.target;

        if (!form || !(target instanceof Element)) return;

        var control = target.closest('button, input[type="submit"], [role="button"]');
        if (!control || !form.contains(control)) return;

        var isSubmitControl =
          control.matches('button[type="submit"], input[type="submit"]') ||
          control.matches('button[name="add"], [name="add"]') ||
          control.matches('[data-add-to-cart], [data-submit-button]');

        if (!isSubmitControl) return;

        syncHiddenInputWithForm();
      }

      function bindProductFormActions() {
        var form = getProductForm();
        if (!form || form.dataset.tcGiftMessageActionReady === componentInstanceId) return;
        form.dataset.tcGiftMessageActionReady = componentInstanceId;

        ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (eventName) {
          form.addEventListener(eventName, syncBeforeProductFormAction, true);
        });
      }

      function getPrimaryAddToCartControl() {
        var form = getProductForm();
        if (!form) return null;

        return Array.prototype.slice
          .call(form.querySelectorAll('button, input[type="submit"], [role="button"]'))
          .find(function (control) {
            if (!(control instanceof Element)) return false;
            if (control.closest('[data-tc-gift-message]')) return false;

            return (
              control.matches('button[type="submit"], input[type="submit"]') ||
              control.matches('button[name="add"], [name="add"]') ||
              control.matches('[data-add-to-cart], [data-submit-button], .add-to-cart-button')
            );
          });
      }

      function controlIsDisabled(control) {
        if (!control) return true;
        return (
          control.disabled === true ||
          control.getAttribute('aria-disabled') === 'true' ||
          control.classList.contains('disabled')
        );
      }

      function clickPrimaryAddToCart() {
        var addToCartControl = getPrimaryAddToCartControl();
        if (!addToCartControl || controlIsDisabled(addToCartControl)) return;

        syncHiddenInputWithForm();
        addToCartControl.click();
      }

      function bindNativeStickyAddToCartActions() {
        document
          .querySelectorAll('sticky-add-to-cart .sticky-add-to-cart__button')
          .forEach(function (button) {
            if (!(button instanceof Element)) return;
            if (button.dataset.tcGiftMessageNativeStickyReady === componentInstanceId) return;
            button.dataset.tcGiftMessageNativeStickyReady = componentInstanceId;

            button.addEventListener(
              'click',
              function (event) {
                if (!isActiveGiftRoot()) return;
                event.preventDefault();
                event.stopPropagation();
                if (typeof event.stopImmediatePropagation === 'function') {
                  event.stopImmediatePropagation();
                }

                clickPrimaryAddToCart();
              },
              true
            );
          });
      }

      save.addEventListener('click', saveMessage);

      textarea.addEventListener('keydown', function (event) {
        if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
          saveMessage();
        }
        if (event.key === 'Escape') {
          closeModal();
        }
      });

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeModal);
      });

      syncHiddenInputWithForm();
      bindProductFormSubmit();
      bindProductFormActions();
      bindNativeStickyAddToCartActions();
      window.setTimeout(bindNativeStickyAddToCartActions, 300);
    }

    document.querySelectorAll('[data-tc-gift-message]').forEach(initGiftMessage);
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-tc-gift-message]').forEach(initGiftMessage);
    });
  })();
